import { lazy } from "react";
/* eslint-disable import/prefer-default-export */
export { default as SelectBox } from "./Select";

export const Eruda = lazy(() => import("./Eruda"));
